import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DashboardState {
  opportunities: any[];
}

const initialState: DashboardState = {
  opportunities: [],
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setOpportunities: (
      state,
      { payload }: PayloadAction<DashboardState["opportunities"]>
    ) => {
      state.opportunities = payload;
    },
    clearOpportunities: (state) => {
      state.opportunities = [];
    },
  },
});

export const { setOpportunities, clearOpportunities } = dashboardSlice.actions;
